module.exports = __webpack_public_path__ + "static/img/cyjj.39f0096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/cyjj.png
// module id = T73E
// module chunks = 0